import {
    setStartMutedPolicy,
    setFollowMe
} from './react/features/base/conference/actions';
import {
    muteRemoteParticipant,
    kickParticipant,
    participantUpdated
} from './react/features/base/participants/actions';

import { getParticipantById, getParticipantCount } from './react/features/base/participants/functions';

import { createRemoteVideoMenuButtonEvent } from './react/features/analytics/AnalyticsEvents';
import { sendAnalytics } from './react/features/analytics/functions';

import {
    setAudioMuted,
} from './react/features/base/media/actions';
import {
    maybeRedirectToWelcomePage
} from './react/features/app/actions';
import JitsiLocalStorage from './modules/util/JitsiLocalStorage';
// import { jitsiLocalStorage } from '@jitsi/js-utils';
import * as apiAction from './apiActionBoomea';
import { appendSuffix } from './react/features/display-name/functions';

var boomeaSource = { url: "", target: "", domain: "", roomId: 0 };
var localRoom = undefined;


/**
 * Handles message send from boomea UI
 *
 * @param {Object} event - The event object
 * field.
 * @protected
 * @returns {void}
 */
function receivedBoomeaMessage(event) {
    switch (event.data.type) {
        case 'connectMeetingApp':
            boomeaSource = {
                url: event.data.url,
                target: event.source,
                domain: event.origin
            };
            event.source.postMessage({ type: "meetingConnected" }, event.origin)
            break;
        case 'meetingInProgress':
            if (event.data.room) {

            }
            break;
        case 'desktopSources':
            window.JitsiMeetElectron = window.JitsiMeetElectron || {};
            window.JitsiMeetElectron.desktopSources = event.data.sources;
            break;
    }
}

function sendMessageToBoomea(evnt, muted = false, room = '', options = {}) {
    if (evnt == 'meetingEnd') {
        // send message to boomea about meeting end
        if (boomeaSource.url) {
            boomeaSource.target.postMessage({ url: boomeaSource.url, value: '', meetingId: JitsiLocalStorage.getItem('boomeaSourceRoomId'), type: 'meetingEnd' }, boomeaSource.domain);
        }
    } else if (evnt == 'audioMuted') {
        if (JitsiLocalStorage.getItem('boomeaSourceRoomId') && boomeaSource.url) {
            boomeaSource.target.postMessage({ url: boomeaSource.url, value: muted, type: 'mic_mute' }, boomeaSource.domain);
        }
    } else if (evnt == 'meetingStart') {
        if (boomeaSource.url !== "") {
            boomeaSource.target.postMessage({ url: boomeaSource.url, value: room, type: 'meetingStart' }, boomeaSource.domain);
        }
    } else if (evnt == 'startDesktopSourcesRequest') {
        if (boomeaSource.url !== "") {
            boomeaSource.target.postMessage({ url: boomeaSource.url, value: room, type: 'startDesktopSourcesRequest',options }, boomeaSource.domain);
        }
    } else if (evnt == 'stopDesktopSourcesRequest') {
        if (boomeaSource.url !== "") {
            boomeaSource.target.postMessage({ url: boomeaSource.url, value: room, type: 'stopDesktopSourcesRequest',options }, boomeaSource.domain);
        }
    }
}

function handleConferenceJoined() {
    // check meetingType and select three checkboxes in Settings More tab if meetingType is 2 i.e. presentation mode
    if (APP.store.getState()['features/base/jwt'].meetingType == 2) {
        // presentation mode 
        setTimeout(() => {
            APP.store.dispatch(setStartMutedPolicy(true, true));
            APP.store.dispatch(setFollowMe(true));
        }, 500);
    }

    //check audionType and make user join as muted if audio type is 2 i.e. dialin audio
    if (APP.store.getState()['features/base/jwt'].audioType == 2) {
        // dialin audio
        muteLocalAudio(true);
    }
}

function _ajaxcall(request, room_id, data, meeting_type, mod_audio_type, mod_code) {
    var user = '';
    if (request == 0) {
        // add room record to db
        user = { room_id, meeting_type, mod_audio_type, mod_code };
        apiAction.addRoom(
            user,
            (response) => { },
            (error) => { }
        );
    } else if (request == 5) {
        // update user email in user table to db
        user = { user_id: room_id, email: data, meeting_type };
    } else if (request == 6) {
        // update user name in user table to db
        user = { user_id: room_id, name: data, meeting_type };
    }
}

function createInitialLocalTracksAndConnect(roomName, data) {
    if (APP.boomeaDebug) {
        console.log('DEBUG2, conference.js, createInitialLocalTracksAndConnect, after tryCreateLocalTracks and connect(roomName)');

        //console.log(con);
        console.log(APP.store.getState()['features/base/jwt'])
        console.log(APP.store.getState()['features/base/jwt'].meetingType)
        console.log(APP.store.getState()['features/base/jwt'].modAudioType)
        console.log(APP.store.getState()['features/base/jwt'].modCode)
    }
    var data = '';

    // this ajax call adds the roomID
    _ajaxcall(
        0,
        roomName,
        data,
        APP.store.getState()['features/base/jwt'].meetingType,
        APP.store.getState()['features/base/jwt'].modAudioType,
        APP.store.getState()['features/base/jwt'].modCode,
    );
}

function userJoined(user, id, room, roomid, rname) {


    var name = user.getDisplayName();
    var username1 = name;
    //change name
    var splitnamenum1 = username1.split("-");
    var audiopinTemp1 = splitnamenum1[0];

    if (APP.boomeaDebug)
        console.log('confcustomizedmeettest0');

    if (Number.isInteger(Number(audiopinTemp1)) && audiopinTemp1.length <= 3) {
        const formattedDisplayName1 = username1.replace(audiopinTemp1 + '-', '');
        console.error("displayName1========>");
        console.error(formattedDisplayName1);


        APP.store.dispatch(participantUpdated({
            conference: room,
            id,
            name: formattedDisplayName1
        }));
        APP.API.notifyDisplayNameChanged(id, {
            displayName: formattedDisplayName1,
            formattedDisplayName:
                appendSuffix(
                    formattedDisplayName1
                    || interfaceConfig.DEFAULT_REMOTE_DISPLAY_NAME)
        });

        APP.store.dispatch(participantUpdated({
            conference: room,
            id,
            name: "unname"
        }));

        APP.API.notifyDisplayNameChanged(id, {
            displayName: "unname",
            formattedDisplayName:
                appendSuffix(
                    "unname"
                    || interfaceConfig.DEFAULT_REMOTE_DISPLAY_NAME)
        });

        var userdtaa = { room_id: roomid, pin: audiopinTemp1 };

        if (APP.boomeaDebug)
            console.log('confcustomizedmeettest');

        apiAction.getMeetingAudioPinDetail(
            userdtaa,
            (response) => {
                if (APP.boomeaDebug) {
                    console.log('confcustomizedmeettest2:', response);
                }
                var unname = response.username;
                var avtar = response.avatar;

                if (!parseInt(response.boomea_user_id)) {
                    return;
                }

                APP.store.dispatch(participantUpdated({
                    conference: room,
                    id,
                    name: unname,
                    avatarURL: avtar
                }));

                APP.API.notifyDisplayNameChanged(id, {
                    displayName: unname,
                    formattedDisplayName:
                        appendSuffix(
                            unname
                            || interfaceConfig.DEFAULT_REMOTE_DISPLAY_NAME)
                });


                //APP.API.notifyAvatarChanged(id, avtar);

                if (APP.boomeaDebug)
                    console.log('confcustomizedmeettest2');
            },
            (error) => {

            }
        );
    }

    // end change name
    if (APP.boomeaDebug)
        console.log('customizedmeetUserJoined');
    localRoom = room;
    const displayName = user.getDisplayName();
    if (APP.boomeaDebug) {
        console.log("_displayName 1792");
        console.log(displayName);
    }
    //var splitDisplayName = Object.keys(user)[3].split('-');
    //var newAudioPin = splitDisplayName[0];
    //console.log("newAudioPin"+newAudioPin);
    //logger.log(`USER ${id} connnected:`, user);

    // check the roles for the new user and reflect them
    // modules/UI/UI.js, updates UI based on roles, like moderator indicator and participant notifications
    //APP.UI.updateUserRole(user);

    /*new code start here*/
    //var Ddata = getuserbyid(id);
    var role = role;
    var id = id;
    var ROLE = '';
    var email = '';
    //var username = Ddata.name;

    var _jid = Object.keys(user)[0];
    var _id = Object.keys(user)[1];
    var _conference = Object.keys(user)[2];
    var _displayName = Object.keys(user)[3];
    var _displayNamen = Object.keys(user)[24];
    var _role = Object.keys(user)[6];

    var _jid = user[_jid];
    var _id = user[_id];
    var _conference = user[_conference];
    var _displayName = user[_displayName];
    var _displayNamen = user[_displayNamen];
    var _role = user[_role];
    var ROLE = 'participant';

    if (APP.boomeaDebug)
        console.log('customizedmeetUserJoined2:', displayName);

    setTimeout(function () {



        var str = name;
        var splitnamenum = str.split("-");
        var audiopinTemp = splitnamenum[0];
        var callernumber = splitnamenum[1];
        var callername = splitnamenum[2];
        var userdataCHK = { user_id: _id, audiopin: parseInt(audiopinTemp) };
        if (Number.isInteger(Number(audiopinTemp))) {
            if (APP.boomeaDebug) {
                console.log('DEBUG7, conference.js, room.on(JitsiConferenceEvents.USER_JOINED..., found temp audio pin inside name')
            }
            apiAction.checkAudioPin(
                userdataCHK,
                (response) => {
                    if (response == '2') {
                        if (APP.store.getState()['features/base/jwt'].meetingType == 2) {
                            // if this dialin pin matches that of moderator, then need to pin this stream so everone hears it
                            if (APP.boomeaDebug) {
                                console.log('DEBUG7, conference.js, room.on(JitsiConferenceEvents.USER_JOINED..., ajax call(req19 with audio pin), resp=success and 2, meetingType=2')
                                console.log(id)
                            }
                            // not needed since dominant Speaker will activate moderator
                            // APP.store.dispatch(pinParticipant(id));
                        } else {
                            if (APP.boomeaDebug) {
                                console.log('DEBUG7, conference.js, room.on(JitsiConferenceEvents.USER_JOINED..., ajax call(req19 with audio pin), resp=success and 2, meetingType=1')
                            }
                            // hide participant info from filestrip
                            $('#participant_' + id).hide();
                            // suppress notifications
                            $('.notifications--group').attr("style", "display: none !important");
                            // activate current user by user clicking on themselves
                            $('#localVideoContainer').click();
                            if (APP.boomeaDebug) {
                                console.log('#participant_' + id);
                            }
                        }
                    } else {
                        if (APP.boomeaDebug) {
                            console.log('DEBUG7, conference.js, room.on(JitsiConferenceEvents.USER_JOINED..., ajax call(req19 with audio pin), resp=success and not 2')
                        }
                        // turn on notifications
                        $('.notifications--group').attr("style", "display: block !important");
                        // show participant
                        $('#participant_' + id).show();
                        APP.API.notifyUserJoined(id, {
                            displayName,
                            formattedDisplayName: appendSuffix(displayName || interfaceConfig.DEFAULT_REMOTE_DISPLAY_NAME)
                        });
                        APP.UI.addUser(user);
                    }
                },
                (error) => {
                    if (APP.boomeaDebug) {
                        console.log('DEBUG7, conference.js, room.on(JitsiConferenceEvents.USER_JOINED..., ajax call(req19 with audio pin), resp=error')
                        //console.log(xhr, resp, text);
                    }
                }
            );

            // add user to db if they do not already exist, via ajax call
            var userdata = { privillage: _role, user_id: _id, role: ROLE, room_id: roomid, audiopin: parseInt(audiopinTemp), sipaudio: 1, calleridname: callername, username: callername, email: email, rname: rname, calleridnumber: callernumber };
            if (APP.boomeaDebug) {
                console.log('customizedmeet addCallerUser pre', userdata);
            }
            apiAction.addCallerUser(
                userdata,
                (response) => {
                    if (APP.boomeaDebug) {
                        console.log('DEBUG7, conference.js, room.on(JitsiConferenceEvents.USER_JOINED..., ajax call(req9, add user), resp=success')
                        //console.log('success');
                    }
                },
                (error) => {
                    if (APP.boomeaDebug) {
                        console.log('DEBUG7, conference.js, room.on(JitsiConferenceEvents.USER_JOINED..., ajax call(req9, add user), resp=error')
                        //console.log(xhr, resp, text);
                    }
                }
            );
            if (APP.boomeaDebug) {
                console.log('customizedmeet addCallerUser post');
            }
            // if(Number.isInteger(Number(callernumber))){
            //     var audiopinTemp = callernumber;
            //     console.log("New audio pin")
            //     console.log(audiopinTemp)
            //     console.log("user id")
            //     console.log(_id);
            //     var updateUserData = {id:_id,audiopin:audiopinTemp,sipaudio:1,roomID:roomid,request:18}
            //     $.ajax({
            //         url: "dbcon/db.php",
            //         type : "POST",
            //         contentType : 'application/x-www-form-urlencoded',
            //         data : updateUserData,
            //         success : function(response) {
            //             console.log('success audio pin updated');
            //             console.log(response)
            //         }.bind(this),
            //         error: function(xhr, resp, text){
            //             //console.log(xhr, resp, text);
            //         }
            //     });
            // }

            // at this point every user gets this USER_JOINED event, and
            // if the joining user is a dialin (as determined by the if above)
            // and the current user is the moderator and meetType=2, and pin not moderator pin (not themselves)
            // then moderator needs to mute all dialin
            if (APP.boomeaDebug) {
                console.log('DEBUG8, conference.js, room.on(JitsiConferenceEvents.USER_JOINED..., mute dialins at conference level, get ready to check')
                console.log(room.isModerator());
                console.log(APP.store.getState()['features/base/jwt']);
                console.log(APP.store.getState()['features/base/jwt'].meetingType);
                console.log(APP.store.getState()['features/base/jwt'].modCode);
                console.log(audiopinTemp);
            }
            // if currUser = moderator && mT==2 && and not mod pin {
            if (JitsiLocalStorage.getItem('owner') && JitsiLocalStorage.getItem('owner') == id && APP.store.getState()['features/base/jwt'].meetingType == 2 && APP.store.getState()['features/base/jwt'].modCode !== audiopinTemp) {
                if (APP.boomeaDebug) {
                    console.log('DEBUG8, conference.js, room.on(JitsiConferenceEvents.USER_JOINED..., mute dialins at conference level')
                }
                APP.store.dispatch(muteRemoteParticipant(id));
            }

        } else {
            if (APP.boomeaDebug) {
                console.log('DEBUG7, conference.js, room.on(JitsiConferenceEvents.USER_JOINED..., did not find temp audio pin inside name')
            }
            APP.API.notifyUserJoined(id, {
                displayName,
                formattedDisplayName: appendSuffix(displayName || interfaceConfig.DEFAULT_REMOTE_DISPLAY_NAME)
            });
            APP.UI.addUser(user);
        }
    }, 6000);

    /* setInterval(function(){
        if (APP.boomeaDebug) {
            console.log('DEBUG7, conference.js, room.on(JitsiConferenceEvents.USER_JOINED..., req 14, check kickout, start')
        }
        var localParticipant = getLocalParticipant(APP.store.getState());
        var localId = localParticipant.id;
        var userdata2 = {user_id:localId ,request:14};
        //AuthHandler.logout(room).then(url => {
        apiAction.checkKickout(
            userdata2,
            (response) => {
                if (APP.boomeaDebug) {
                    console.log('DEBUG7, conference.js, room.on(JitsiConferenceEvents.USER_JOINED..., req 14, check kickout, success')
                    //console.log(response);
                }
                if(response=='true'){
                    if (APP.boomeaDebug) {
                        console.log('DEBUG7, conference.js, room.on(JitsiConferenceEvents.USER_JOINED..., req 14, check kickout, success and response = true, so kickout')
                    }
                    APP.UI.hideStats();
                    APP.UI.notifyKicked();
                    setTimeout(function(){
                        window.sessionStorage.setItem('revoke', 1);
                        jQuery('.swal2').click();
                        return false;
                    },3500)
                }
            },
            (error) => {
                if (APP.boomeaDebug) {
                    console.log('DEBUG7, conference.js, room.on(JitsiConferenceEvents.USER_JOINED..., req 14, check kickout, error')
                    //console.log(xhr, resp, text);
                }
            }
        );
        // });
    }, 3000); */
    /*new code end here*/
}

function muteLocalAudio(muted) {
    APP.store.dispatch(setAudioMuted(muted));
}

function userRoleChanged(id, role, Ddata, isModerator, room_id, room) {


    window.sessionStorage.setItem('passerror', '');
    window.sessionStorage.setItem('IDDDD', id);
    var role = role;
    var id = id;
    var ROLE = '';
    var jitsiUser = getParticipantById(APP.store.getState(), Ddata);
    console.error('jitsiUser1:=======>');
    console.error(jitsiUser);
    var email = jitsiUser.email;
    var username = jitsiUser.name;




    if (username == '') {
        username = 'anonymous';
    }
    const { boomeauser } = APP.store.getState()['features/base/jwt'];
    if (APP.boomeaDebug) {
        console.log("Line 1976")
        console.log(boomeauser)
    }
    var boomea_team_idd = boomeauser.boomea_team_id;
    var boomea_user_idd = boomeauser.boomea_user_id;
    var audiopinn = boomeauser.audiopin;
    var sipaudioo = boomeauser.sipaudio;

    if (APP.boomeaDebug) {
        console.log('audiopinn line 1981 conference.js' + audiopinn);

        console.log('sipaudioo line 1982 conference.js' + sipaudioo);
    }

    if (JitsiLocalStorage.getItem('owner') && JitsiLocalStorage.getItem('owner') == id) {
        // console.log('conference if sipaudio: ' + sipaudioo + ' audiopin: ' + audiopinn + ' id: ' + id);
        ROLE = 'owner';
    } else {
        ROLE = 'participant';
    }

    var user2 = {
        audiopin: parseInt(audiopinn),
        sipaudio: parseInt(sipaudioo),
        boomea_team_id: parseInt(boomea_team_idd),
        boomea_user_id: parseInt(boomea_user_idd),
        privillage: role, user_id: id, role: ROLE, room_id, username: username, email: email
    };

    if (!JitsiLocalStorage.getItem('owner')) {
        user2 = {
            audiopin: parseInt(audiopinn),
            sipaudio: parseInt(sipaudioo),
            boomea_team_id: parseInt(boomea_team_idd),
            boomea_user_id: parseInt(boomea_user_idd),
            privillage: role, user_id: id, room_id, username: username, email: email
        };
    }

    /* apiAction.updateUser(
        user2,
        (response) => {
            JitsiLocalStorage.setItem('audiopin', audiopinn)
            window.sessionStorage.setItem('audiopinnN', audiopinn);
            if(APP.boomeaDebug) {
                console.log('conference if success ' + 'audiopinn: ' + audiopinn);
            }
        },
        (error) => {

        }
    ); */


    /* var userdata21 = {id:id ,request:21};
    setInterval(function(){
            apiAction.checkMuted(
            userdata21,
            (response) => {
                if(response=='false'){
                    if( window.sessionStorage.getItem('off') == 1){
                            window.sessionStorage.setItem('off', 0);
                            $('.boom-microphone').parents().css('pointer-events','');
                            muteLocalAudio(false);
                    }
                } else {
                    window.sessionStorage.setItem('off', 1);
                    $('.boom-microphone').parents().css('pointer-events','none');
                    muteLocalAudio(true);
                }
            },
            (error) => {
            }
        );
    },100000); */

}

function hangup(room_id, user_id, leaveRoom) {

    if(!user_id){
        return ;
    }

    return new Promise((resolve, reject) => {
        let isModerator = false;
        if (JitsiLocalStorage.getItem('owner') && JitsiLocalStorage.getItem('owner') == user_id) {
            isModerator = true;
        }
        var userDta;
        var len = getParticipantCount(APP.store.getState());

        var mod = 0;
        if (isModerator) {
            mod = 1;
            len = 0;
        }

        userDta = { room_id, status: "Left", length: len, mod, user_id };

        const { boomeauser } = APP.store.getState()['features/base/jwt'];

        Promise.all([
            leaveRoom()
        ]).then(values => {
            //leaveRoom();

            if (APP.boomeaDebug)
                console.log('meetingleft1');

            if (isModerator) {
                var leftDta = { room_id, status: "Left" };
                apiAction.meetingsLeftAll(
                    leftDta,
                    (response) => { },
                    (error) => { }
                );
            }

            apiAction.meetingsLeft(
                userDta,
                (response) => {
                    // send message to boomea about meeting end
                    if (APP.boomeaDebug)
                        console.log(boomeauser);

                    if (boomeauser && parseInt(boomeauser.boomea_user_id) && boomeaSource.url) {
                        boomeaSource.target.postMessage({ url: boomeaSource.url, value: '', meetingId: JitsiLocalStorage.getItem('boomeaSourceRoomId'), type: 'meetingEnd' }, boomeaSource.domain);
                    } else {
                        //guest user
                        APP.API.notifyReadyToClose();
                        APP.store.dispatch(maybeRedirectToWelcomePage());
                    }
                    resolve();
                },
                (error) => {
                    // send message to boomea about meeting end
                    if (boomeauser && parseInt(boomeauser.boomea_user_id) && boomeaSource.url) {
                        boomeaSource.target.postMessage({ url: boomeaSource.url, value: '', meetingId: JitsiLocalStorage.getItem('boomeaSourceRoomId'), type: 'meetingEnd' }, boomeaSource.domain);
                    } else {
                        //guest user
                        APP.API.notifyReadyToClose();
                        APP.store.dispatch(maybeRedirectToWelcomePage());
                    }
                    resolve();
                }
            );
        });

    });
}

function closeMeeting(user_id, room) {
    return new Promise((resolve, reject) => {
        //close meeting if leaving user is owner and moderator
        if (APP.boomeaDebug) {
            console.log('customizedmeetclose 0', JitsiLocalStorage.getItem('owner'), user_id);
        }
        let isMeetingOwner = false;
        if (JitsiLocalStorage.getItem('owner') && JitsiLocalStorage.getItem('owner') == user_id) {
            isMeetingOwner = true;
            const { conference } = APP.store.getState()['features/base/conference'];
            let participants = conference.getParticipants();

            if (APP.boomeaDebug) {
                console.log('customizedmeetclose 2', participants);
            }
            //let ownerPart = room.getParticipantById(user_id);

            participants.map(participant => {
                if (APP.boomeaDebug) {
                    console.log('customizedmeetclose 6', participant.getId());
                }
                if (participant.getId() != user_id) {
                    //let part = room.getParticipantById(participant.getId());
                    //if(APP.boomeaDebug) {
                    //console.log('customizedmeetclose 8', part);
                    //}
                    //APP.store.dispatch(kickedOut(room, part));
                    sendAnalytics(createRemoteVideoMenuButtonEvent(
                        'kick.button',
                        {
                            'participant_id': participant.getId()
                        }));
                    APP.store.dispatch(kickParticipant(participant.getId()));
                }
            });
        }

        let timeot = 2500;
        if (isMeetingOwner) {
            setTimeout(function () {
                if (APP.boomeaDebug) {
                    console.log('customizedmeetclose 10');
                }
                resolve();
                if (APP.boomeaDebug) {
                    console.log('customizedmeetclose 11');
                }
            }, timeot);
        } else {
            resolve();
            if (APP.boomeaDebug) {
                console.log('customizedmeetclose 9');
            }
        }
    });
}

function closeMeetingOnClose(user_id, room) {
    room.getParticipants().map(participant => {
        if (APP.boomeaDebug) {
            console.log('customizedmeetclose 6', participant.getId());
        }
        if (participant.getId() != user_id) {
            if (APP.boomeaDebug) {
                console.log('customizedmeetclose 8', participant.getId());
            }
            //APP.store.dispatch(kickedOut(room, part));
            sendAnalytics(createRemoteVideoMenuButtonEvent(
                'kick.button',
                {
                    'participant_id': participant.getId()
                }));
            APP.store.dispatch(kickParticipant(participant.getId()));
        }
    });
}

function _onConferenceJoined(isModerator, Ddata, room_id, room, myUserId) {

    var ROLE;
    var role;
    var len = room.getParticipants().map(p => p.getId());
    if (len == 0) {
        ROLE = 'owner';
        role = 'moderator';
    } else {
        ROLE = 'participant';
        role = 'participant';
    }
    var jitsiUser = getParticipantById(APP.store.getState(), Ddata);
    console.error('jitsiUser1:=======>');
    console.error(jitsiUser);
    var email = jitsiUser.email;
    var username = jitsiUser.name;


    if (username == '') {
        username = 'anonymous';
    }
    const { boomeauser } = APP.store.getState()['features/base/jwt'];
    if (APP.boomeaDebug) {
        console.log("Line 1976")
        console.log(boomeauser)
    }
    var boomea_team_idd = boomeauser.boomea_team_id;
    var boomea_user_idd = boomeauser.boomea_user_id;
    var audiopinn = boomeauser.audiopin;
    var sipaudioo = boomeauser.sipaudio;

    var user2 = {
        audiopin: parseInt(audiopinn),
        sipaudio: parseInt(sipaudioo),
        boomea_team_id: parseInt(boomea_team_idd),
        boomea_user_id: parseInt(boomea_user_idd),
        privillage: role, user_id: myUserId, role: ROLE, room_id, username: username, email: email
    };
    apiAction.addUser(
        user2,
        (response) => {
            if (APP.boomeaDebug) {
                console.log('customizedmeetadduser', response);
            }
            JitsiLocalStorage.setItem('audiopin', audiopinn);
            window.sessionStorage.setItem('audiopinnN', audiopinn);
            if (response.owner_id) {
                JitsiLocalStorage.setItem('owner', response.owner_id);

                if (APP.boomeaDebug)
                    console.log('customizedmeetadduser', JitsiLocalStorage.getItem('owner'));

                if (response.owner_id == user2.user_id) {
                    setInterval(function () {
                        if (APP.boomeaDebug) {
                            console.log('update Last Active at')
                        }
                        var mla = { user_id: user2.user_id, room_id }
                        apiAction.meetingUpdateLastActive(
                            mla,
                            (sresponse) => {
                                if (APP.boomeaDebug) {
                                    console.log('updateLastActive', sresponse);
                                }
                            },
                            (ferror) => {
                                if (APP.boomeaDebug) {
                                    console.log('updateLastActive', ferror);
                                }
                            }
                        );
                    }, 180000);
                }

                if (response.owner_id != user2.user_id) {
                    const { boomeauser } = APP.store.getState()['features/base/jwt'];
                    if (APP.boomeaDebug) {
                        console.log(boomeauser, boomeaSource, 'meetingUserAdded');
                    }
                    if (boomeauser && parseInt(boomeauser.boomea_user_id) && boomeaSource.url) {
                        boomeaSource.target.postMessage({ url: boomeaSource.url, value: room_id, type: 'meetingUserAdded' }, boomeaSource.domain);
                    }
                }
            }
            // console.log('conference else success ' + 'user2: ' + user2 + ' user2.id: ' + user2.id + ' user2.audiopin: ' + user2.audiopin);
            //console.log('success');
        },
        (error) => {

        }
    );


    var meeting_info = { room_id };
    apiAction.getMeetingId(
        meeting_info,
        (response) => {
            if (APP.boomeaDebug) {
                console.log('customizedmeetGetMeetingId', response);
            }
            if (response.id) {
                JitsiLocalStorage.setItem('boomeaSourceRoomId', response.id);
            }
            // console.log('conference else success ' + 'user2: ' + user2 + ' user2.id: ' + user2.id + ' user2.audiopin: ' + user2.audiopin);
            //console.log('success');
        },
        (error) => {

        }
    );

    var text = JSON.stringify({ room_id, user_id: myUserId });
    const { redirectUrl } = APP.store.getState()['features/base/jwt'];
    let url = redirectUrl.replace('/join', '/api/v4/meetings/userleft');

    if (typeof navigator.sendBeacon === "function") {
        window.addEventListener('unload', (event) => {

            navigator.sendBeacon(url, text);
        });
    } else {
        window.addEventListener('beforeunload', (event) => {
            //event.stopImmediatePropagation();
            //event.preventDefault();

            if (window.sessionStorage.getItem("revoke") == null) {
                if (JitsiLocalStorage.getItem('owner') && JitsiLocalStorage.getItem('owner') == myUserId) {
                    //close meeting if meeting owner leaves
                    //closeMeetingOnClose(myUserId, room, true);
                    // meeting owner
                    var modDta = { room_id, status: "Left", length: 0, mod: 1, user_id: myUserId };
                    apiAction.leftBrowser(
                        modDta,
                        (response) => { },
                        (error) => { }
                    );
                    /* var modDta = {room_id, status:"Left",length:0, mod:1, user_id: myUserId};
                    console.log('meetingleft2');
                    apiAction.meetingsLeft(
                        modDta,
                        (response) => {},
                        (error) => {}
                    ); */
                } else if (myUserId.length > 0) {
                    var userDta = { room_id, status: "Left", length: len, mod: mod, user_id: myUserId };
                    apiAction.leftBrowser(
                        userDta,
                        (response) => { },
                        (error) => { }
                    );
                }
            }
            //event.returnValue = `Are you sure you want to leave?`;
        });
    }

    if (APP.boomeaDebug) {
        console.log('DEBUG1, conference.js, _onConferenceJoined, before participant check')
        console.log(isModerator);
    }
    if (APP.boomeaDebug) {
        console.log(isModerator);
    }
    var len = getParticipantCount(APP.store.getState());
    if (APP.boomeaDebug) {
        console.log(len);
        console.log('DEBUG1, conference.js, _onConferenceJoined, before check mod')
    }
    var mod = 0;
    if (isModerator) {
        mod = 1;
    }
    if (APP.boomeaDebug) {
        console.log(mod);
    }


    window.sessionStorage.setItem('IDDDD', myUserId);

    // turn off keyboard shortcuts for presentation guests
    if (APP.boomeaDebug) {
        console.log('DEBUG1, conference.js, _onConferenceJoined, before keyboardshortcut enable/disable')
        console.log(APP.store.getState()['features/base/jwt'].meetingType);
        console.log(len);
    }
    if ((APP.store.getState()['features/base/jwt'].meetingType == 2) && (len > 0)) {
        if (APP.boomeaDebug) {
            console.log('DEBUG1, conference.js, _onConferenceJoined, set keyboardshortcut off')
        }
        APP.keyboardshortcut.enable(false);
    }
}

function kickButton(data) {
    apiAction.kickOut(
        data,
        (response) => { },
        (error) => { }
    );
}


function kickOutParticipant(leaveRoom, room_id, user_id) {
    if (APP.boomeaDebug) {
        console.log('customizedmeetclose 7 kickout');
    }
    leaveRoom();


    const { boomeauser } = APP.store.getState()['features/base/jwt'];
    if (APP.boomeaDebug) {
        console.log(boomeauser, boomeaSource, 'customizedmeetkick');
    }

    var len = getParticipantCount(APP.store.getState());

    var mod = 0;

    // update user status left if user is jigasi user
    var userDtaa = { user_id, room_id, status: "Left" };
    apiAction.callerLeft(
        userDtaa,
        (response) => { },
        (error) => { }
    );

    var userDta = { room_id, status: "Left", length: len, mod, user_id };
    apiAction.meetingsLeft(
        userDta,
        (response) => {
            if (boomeauser && parseInt(boomeauser.boomea_user_id) && boomeaSource.url) {
                boomeaSource.target.postMessage({ url: boomeaSource.url, value: '', meetingId: JitsiLocalStorage.getItem('boomeaSourceRoomId'), type: 'meetingEnd' }, boomeaSource.domain);
            } else {
                // guest user
                APP.API.notifyReadyToClose();
                APP.store.dispatch(maybeRedirectToWelcomePage());
            }
        },
        (error) => {
            if (boomeauser && parseInt(boomeauser.boomea_user_id) && boomeaSource.url) {
                boomeaSource.target.postMessage({ url: boomeaSource.url, value: '', meetingId: JitsiLocalStorage.getItem('boomeaSourceRoomId'), type: 'meetingEnd' }, boomeaSource.domain);
            } else {
                // guest user
                APP.API.notifyReadyToClose();
                APP.store.dispatch(maybeRedirectToWelcomePage());
            }
        }
    );

}

function kickOutItself(room_id, left_user_id, user_id, leaveRoom) {
    if (left_user_id == user_id) {
        // if leaving user id is same as current user id 
        // we don't need to run left api call in such cases
        return;
    }
    if (APP.boomeaDebug) {
        console.log('customizedmeetclose 17 kickout');
    }
    // if (JitsiLocalStorage.getItem('owner') && JitsiLocalStorage.getItem('owner') == left_user_id) {
    //     var len = getParticipantCount(APP.store.getState());
    //     let userDta = { room_id, status: "Left", length: len, mod: 0, user_id };

    //     if (APP.boomeaDebug)
    //         console.log('meetingleft3');

    //     const { boomeauser } = APP.store.getState()['features/base/jwt'];

    //     Promise.all([
    //         leaveRoom()
    //     ]).then(values => {
    //         //leaveRoom();

    //         if (user_id) {
    //             apiAction.meetingsLeft(
    //                 userDta,
    //                 (response) => {
    //                     if (boomeauser && parseInt(boomeauser.boomea_user_id) && boomeaSource.url) {
    //                         boomeaSource.target.postMessage({ url: boomeaSource.url, value: '', meetingId: JitsiLocalStorage.getItem('boomeaSourceRoomId'), type: 'meetingEnd' }, boomeaSource.domain);
    //                     } else {
    //                         // guest user
    //                         APP.API.notifyReadyToClose();
    //                         APP.store.dispatch(maybeRedirectToWelcomePage());
    //                     }
    //                 },
    //                 (error) => {
    //                     if (boomeauser && parseInt(boomeauser.boomea_user_id) && boomeaSource.url) {
    //                         boomeaSource.target.postMessage({ url: boomeaSource.url, value: '', meetingId: JitsiLocalStorage.getItem('boomeaSourceRoomId'), type: 'meetingEnd' }, boomeaSource.domain);
    //                     } else {
    //                         // guest user
    //                         APP.API.notifyReadyToClose();
    //                         APP.store.dispatch(maybeRedirectToWelcomePage());
    //                     }
    //                 }
    //             );
    //         }
    //     });

    // }
    // update user status left if user is jigasi user
    var userDtaa = { user_id: left_user_id, room_id, status: "Left" };
    apiAction.callerLeft(
        userDtaa,
        (response) => { },
        (error) => { }
    );
}

function muteUser(user_id) {
    var data = { muted: true, user_id };
    apiAction.muteUser(
        data,
        (response) => { },
        (error) => { }
    );
}

export { receivedBoomeaMessage, sendMessageToBoomea, handleConferenceJoined, _ajaxcall, createInitialLocalTracksAndConnect, userJoined, userRoleChanged, hangup, closeMeeting, closeMeetingOnClose, _onConferenceJoined, kickButton, kickOutParticipant, kickOutItself, muteUser }